export const employeeColumns = [
  { header: "Unique ID", key: "uniqueId", width: 20 },
  { header: "Full Name", key: "fullName", width: 20 },
  { header: "Alias Name", key: "aliasName", width: 20 },
  { header: "Salary Type", key: "salaryType", width: 25 },
  { header: "Salary", key: "salary", width: 20 },
  // { header: "Company", key: "companyCode", width: 20 },
  { header: "Location", key: "locationCode", width: 20 },
  { header: "MOM Trade", key: "momTrade", width: 20 },
  { header: "Trade", key: "netcoTrade", width: 20 },
  { header: "Department", key: "departmentCode", width: 20 },
  { header: "Designation", key: "designationCode", width: 20 },
  { header: "Employee Type", key: "employeeType", width: 20 },
  { header: "Working Mode", key: "employeeWorkType", width: 20 },
  { header: "Employment Type", key: "employmentType", width: 20 },
  { header: "Join Date", key: "joinDate", width: 15 },
  { header: "Contract Expiry", key: "contractExpiryDate", width: 20 },
  { header: "Nationality", key: "nationality", width: 20 },
  { header: "DOB", key: "dob", width: 15 },
  { header: "Pass Type", key: "passCode", width: 20 },
  { header: "NRIC/FIN Number", key: "nricNumber", width: 20 },
  { header: "NRIC/FIN Issue Date", key: "passIssuedDate", width: 20 },
  { header: "NRIC/FIN Expiry Date", key: "passExpiryDate", width: 20 },
  { header: "Work Permit Number", key: "workPermitNumber", width: 20 },
  {
    header: "Work Permit Renewal Date",
    key: "workPermitRenewalDate",
    width: 20,
  },
  { header: "S Pass Number", key: "sPassNumber", width: 20 },
  { header: "Levy Amount Types", key: "levyAmountTypes", width: 20 },
  { header: "Levy Types", key: "levyTypes", width: 20 },
  { header: "Levy Amount", key: "levyAmount", width: 20 },
  { header: "PCP Expiry Date", key: "pcpExpiryDate", width: 20 },
  { header: "PCP Clinic", key: "pcpClinic", width: 20 },
  { header: "Sector", key: "sector", width: 20 },

  { header: "Passport Number", key: "passportNumber", width: 20 },
  { header: "Passport Issued Place", key: "passPortIssuedPlace", width: 20 },
  { header: "Passport Issued Date", key: "passPortIssuedDate", width: 20 },
  { header: "Passport Expiry Date", key: "passPortExpiryDate", width: 20 },
  { header: "Report To", key: "reportTo", width: 20 },

  { header: "Exclude Time", key: "excludeTime", width: 20 },
  { header: "NS Eligible", key: "nsEligible", width: 15 },
  { header: "Probation Start Date", key: "probationPeriodStart", width: 15 },
  { header: "Probation End Date", key: "probationPeriodEnd", width: 15 },
  { header: "Notice Period", key: "lengthofNoticePeriod", width: 20 },
  { header: "Payment Mode", key: "paymentMode", width: 20 },
  // { header: "Pay Amount Type", key: "basicPayAmountType", width: 20 },
  { header: "Bank Name", key: "bankName", width: 20 },
  { header: "Account No", key: "accountNo", width: 20 },

  { header: "Shift Code", key: "groups", width: 15 },
  { header: "Qualification", key: "academicQualification", width: 20 },
  { header: "Gender", key: "gender", width: 10 },
  { header: "Marital Status", key: "maritalStatus", width: 20 },
  { header: "Father Name", key: "fatherName", width: 10 },
  { header: "Mother Name", key: "motherName", width: 20 },
  { header: "Emergency Contact", key: "emergencyContactPerson", width: 20 },
  // { header: "Relationship", key: "relationship", width: 20 },
  { header: "Having Dependants", key: "havingDependants", width: 20 },
  { header: "Having Kids", key: "havingKids", width: 15 },
  { header: "Eating Habit", key: "eatingHabit", width: 20 },
  {
    header: "Accommodation by Company",
    key: "accommodationByCompany",
    width: 25,
  },
  { header: "Contact No", key: "hpno", width: 15 },
  { header: "Local Contact No", key: "localContactNumber", width: 20 },
  { header: "Overseas Contact No", key: "overseasContactNumber", width: 20 },
  { header: "Email", key: "email", width: 25 },
  { header: "Personal Email", key: "personalEmail", width: 25 },

  // { header: "IC No", key: "icno", width: 20 },

  { header: "Address 1", key: "address1", width: 20 },
  { header: "Address 2", key: "address2", width: 20 },
  { header: "Address 3", key: "address3", width: 20 },
  { header: "Country", key: "country", width: 20 },
  { header: "Postal Code", key: "postalCode", width: 15 },
  { header: "Race", key: "race", width: 15 },
  // { header: "Office No", key: "officeNo", width: 15 },

  { header: "Blood Group", key: "bloodGroup", width: 10 },
  { header: "Religion", key: "religion", width: 20 },
  { header: "Remarks", key: "remarks", width: 25 },
  { header: "PPE Size", key: "ppeSize", width: 15 },
  { header: "Shoe Size", key: "shoeSize", width: 15 },
  { header: "PPE Remarks", key: "ppeRemarks", width: 25 },

  { header: "Employment Status", key: "employmentStatus", width: 20 },
  { header: "Skilled/Unskilled", key: "skilledOrUnSkilled", width: 20 },
  { header: "Confirmation Date", key: "confirmationDate", width: 20 },
  { header: "Resigned Date", key: "resignedDate", width: 20 },
  { header: "Job Title", key: "jobTitle", width: 20 },
  { header: "Project", key: "projectCode", width: 20 },

  { header: "Residential Type", key: "residentialType", width: 15 },
  { header: "Contribution Code", key: "contributionCode", width: 20 },
  { header: "PR Date", key: "prDate", width: 15 },
  { header: "PR CPF Type", key: "prcpfType", width: 15 },
  { header: "CPF Entitled", key: "cpfEntitled", width: 20 },
  { header: "Contributes SDL", key: "contributesSDL", width: 20 },
  { header: "SDL Breakdown", key: "sdlBreakdown", width: 20 },
  { header: "Fund Donation", key: "fundDonation", width: 20 },

  { header: "Has OT Pay", key: "haveOverTimePay", width: 15 },
  {
    header: "OT Pay for Extra Hours",
    key: "haveOverTimePayForExtraHours",
    width: 25,
  },
  // { header: "OT Day Salary", key: "otDaySalary", width: 15 },
  // { header: "OT Paid in Days", key: "otPaidInDays", width: 20 },

  { header: "OT1 Pay Rate", key: "oT1PayRate", width: 15 },
  { header: "OT2 Pay Rate", key: "oT2PayRate", width: 15 },
  { header: "OT3 Pay Rate", key: "oT3PayRate", width: 15 },
  { header: "Extra Hours Rate", key: "extraHoursRate", width: 20 },
  { header: "Need Attendance", key: "haveNeedAttendance", width: 20 },
  { header: "Login Permission", key: "haveLoginPermission", width: 20 },
  { header: "Login Username", key: "loginUserName", width: 20 },
  { header: "Rest Day", key: "restDay", width: 15 },
  { header: "Skill Set", key: "skillSet", width: 25 },
  { header: "Working Hours/Day", key: "workingHoursPerDay", width: 20 },
  { header: "Work Days/Week", key: "workDayPerWeek", width: 20 },

  { header: "Working Timing/Day", key: "workingTimingPerDay", width: 20 },
  { header: "Monday Hours", key: "monday", width: 15 },
  { header: "Tuesday Hours", key: "tuesday", width: 15 },
  { header: "Wednesday Hours", key: "wednesday", width: 15 },
  { header: "Thursday Hours", key: "thursday", width: 15 },
  { header: "Friday Hours", key: "friday", width: 15 },
  { header: "Saturday Hours", key: "saturday", width: 15 },
  { header: "Sunday Hours", key: "sunday", width: 15 },
  { header: "Monday Mode", key: "mondayWorkingMode", width: 15 },
  { header: "Tuesday Mode", key: "tuesdayWorkingMode", width: 15 },
  { header: "Wednesday Mode", key: "wednesdayWorkingMode", width: 15 },
  { header: "Thursday Mode", key: "thursdayWorkingMode", width: 15 },
  { header: "Friday Mode", key: "fridayWorkingMode", width: 15 },
  { header: "Saturday Mode", key: "saturdayWorkingMode", width: 15 },
  { header: "Sunday Mode", key: "sundayWorkingMode", width: 15 },
  {
    header: "Have Less Time Deduction",
    key: "haveLessTimeDeduction",
    width: 20,
  },
  { header: "Is Active", key: "isActive", width: 10 },
  { header: "Have FullPay", key: "haveFullPay", width: 10 },
  // { header: "Employee Work Type", key: "", width: 10 },
  { header: "OT Hourly Salary", key: "otHourlySalary", width: 20 },
  { header: "OT Day Salary", key: "otDaySalary", width: 20 },

  { header: "Daily Allowance", key: "dailyAllowance", width: 20 },
  { header: "Pass Issue Date", key: "passIssueDate", width: 20 },
  { header: "Pass Expiry Date", key: "passExpiryDate", width: 20 },
  {
    header: "Noof Working Days Per Week",
    key: "noofworkingDaysPerWeek",
    width: 20,
  },
  { header: "Contract Type", key: "contractType", width: 20 },
  { header: "Default Shift", key: "defaultShift", width: 20 },
  // { header: "Create User", key: "createUser", width: 15 },
  // { header: "Create Date", key: "createDate", width: 20 },
  // { header: "Modify User", key: "modifyUser", width: 15 },
  // { header: "Modify Date", key: "modifyDate", width: 20 },
];
